const encoder = new TextEncoder();

function toBase64Url(bytes: Uint8Array): string {
  let value = "";
  for (const byte of bytes) value += String.fromCharCode(byte);
  return btoa(value).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
}

export function generateProjectApiKey(environment: string): {
  apiKey: string;
  keyPrefix: string;
} {
  const token = new Uint8Array(32);
  crypto.getRandomValues(token);
  const prefix = environment === "production" ? "pdfp_live_" : "pdfp_test_";
  const apiKey = `${prefix}${toBase64Url(token)}`;
  return { apiKey, keyPrefix: apiKey.slice(0, prefix.length + 8) };
}

export async function hashProjectApiKey(apiKey: string, pepper: string): Promise<string> {
  const digest = pepper
    ? await crypto.subtle.sign(
        "HMAC",
        await crypto.subtle.importKey(
          "raw",
          encoder.encode(pepper),
          { name: "HMAC", hash: "SHA-256" },
          false,
          ["sign"],
        ),
        encoder.encode(apiKey),
      )
    : await crypto.subtle.digest("SHA-256", encoder.encode(apiKey));
  return Array.from(new Uint8Array(digest), (byte) => byte.toString(16).padStart(2, "0")).join("");
}

export function hasProjectApiKeyPermissions(
  granted: Record<string, string[]>,
  required?: Record<string, string[]>,
): boolean {
  if (!required) return true;
  return Object.entries(required).every(([resource, actions]) => {
    const allowed = granted[resource] ?? [];
    return actions.every((action) => allowed.includes(action));
  });
}
